/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */
import { Component,  OnInit,HostListener } from '@angular/core';
import { NbTokenLocalStorage, NbAuthToken, NbPasswordAuthStrategy, NbAuthService, NbAuthResult } from '@nebular/auth';
import { AnalyticsService } from './@core/utils/analytics.service';
import { environment } from '../environments/environment';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { Router } from '@angular/router';
import { HttpClient } from '@microsoft/signalr';
import { BloodBankModuleData } from './pages/blood-bank/backend/interface/blood-bank';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { SharedService } from './@core/interfaces/masters/SharedService';
import { Title } from '@angular/platform-browser';
import { FaviconService } from './favicon-service';

@Component({
  selector: 'ngx-app',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit   {
 idleTime = 3600; // 5 minutes
  timeout = 10; 
  lastPing?: Date;

  protected readonly unsubscribe$ = new Subject<void>();

  constructor(private analytics: AnalyticsService,private sharedService:SharedService,  private titleService: Title,
    private faviconService: FaviconService,
              private authStrategy: NbPasswordAuthStrategy,
              private tokenStorage: NbTokenLocalStorage,
              private idle: Idle, private keepalive: Keepalive,private postService: BloodBankModuleData,public router:Router,protected service: NbAuthService) {
             var timeOutHspSettings = localStorage.getItem("sessionTimeOutSettings");
            let timeoutValue = parseInt(timeOutHspSettings);
            this.idleTime = (isNaN(timeoutValue) ? 1440 : timeoutValue) * 60;


             
    this.idle.setIdle(this.idleTime); // Set idle time
    this.idle.setTimeout(this.timeout);
    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES); // Reset timer on activity
        // On session timeout
        this.idle.onTimeout.subscribe(() => {
          this.logout();
        });
     // Reset the idle timer on user activity
     this.idle.watch();
  }

  ngOnInit(): void {
    this.analytics.trackPageViews();
    this.validateSessionTimeout();

    const brandCode = environment.brandCode;
    if (brandCode.key === 'shukhee') {
      this.titleService.setTitle(brandCode.value); 
      this.faviconService.updateFavicon('assets/faviconshukhee.ico');
    } else {
      this.titleService.setTitle('Ezovion HMS');
      this.faviconService.updateFavicon('assets/favicon.ico');
    }
  }


  logout(){
    
    if(this.router.url!="/auth/login" && this.router.url!="/auth/logout"){    
      let postData={
        sessionId:localStorage.getItem("sessionId"),
        tenantId:localStorage.getItem("tenantId"),
        branchId:localStorage.getItem("branchId"),
        LogOutType:"System"
      }
   
      this.postService.searchList("auth/sign-out-webApp",postData).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
        localStorage.clear();
        sessionStorage.clear();
        alert("Your session has expired. Please login again");
        this.router.navigateByUrl("/auth/login");
    
      }, (error) => {
      }, () => {
       
      });
  
    }
  }
  validateSessionTimeout(){
if(localStorage.length==0){
  this.router.navigateByUrl("/auth/login");
  localStorage.clear();
}
  }

  resetIdleTimer() {
    this.idle.watch();
  }
  initTestUserToken() {
    
    const demoTokenInitKey = 'demo_token_initialized';
    const demoTokenWasInitialized = localStorage.getItem(demoTokenInitKey);
    const currentToken = this.tokenStorage.get();
    if (!demoTokenWasInitialized && !currentToken.isValid()) {
      // local storage is clear, let's setup demo user token for better demo experience
      this.tokenStorage.set(this.authStrategy.createToken<NbAuthToken>(environment.testUser.token));
      localStorage.setItem(demoTokenInitKey, 'true');
    }
  }
}
